import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ConfigProvider } from "antd";
import deDE from "antd/lib/locale/de_DE";
import "./locale/de-at"; // Importieren Sie die deutsche Lokalisierung für Day.js
import "dayjs/plugin/timezone"; // Importieren Sie das Timezone-Plugin für Day.js
import { Provider } from "react-redux";
import {store} from './Redux/store';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <ConfigProvider locale={deDE}>
      <App />
    </ConfigProvider>
    </Provider>
  </React.StrictMode>
);
